import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_LOCK: GlameraIconDefinition = {
  name: 'lock',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-lock-group">
      <rect class="glm-lock-body" width="18" height="11" x="3" y="11" rx="2" ry="2"></rect>
      <path class="glm-lock-shackle" d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-lock-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './lock.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LockIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_LOCK;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
